// src/components/admin/SearchFilterBar.jsx
import React from 'react';

const SearchFilterBar = ({ 
  searchTerm, 
  onSearchChange, 
  filters = [], 
  onFilterChange, 
  onResetFilters,
  placeholder = "Rechercher..." 
}) => {
  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 mb-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        {/* Search Input */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Rechercher
          </label>
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none focus:ring-2"
          />
        </div>
        
        {/* Dynamic Filters */}
        {filters.map((filter, index) => (
          <div key={index}>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              {filter.label}
            </label>
            {filter.type === 'select' ? (
              <select
                value={filter.value}
                onChange={(e) => onFilterChange(filter.key, e.target.value)}
                className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none focus:ring-2"
              >
                {filter.options.map((option, optionIndex) => (
                  <option key={optionIndex} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type={filter.type || 'text'}
                value={filter.value}
                onChange={(e) => onFilterChange(filter.key, e.target.value)}
                placeholder={filter.placeholder}
                className="w-full px-2 py-1.5 text-sm border border-slate-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none focus:ring-2"
              />
            )}
          </div>
        ))}
      </div>
      
      {/* Reset Button */}
      <div className="mt-3 flex justify-end">
        <button
          onClick={onResetFilters}
          className="px-3 py-1.5 text-sm bg-slate-200 text-gray-700 rounded-lg hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          Réinitialiser les filtres
        </button>
      </div>
    </div>
  );
};

export default SearchFilterBar;